import { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { schedulerConfigJsonSequence } from '@leadflow/shared/src/common/components/Helper/Helper';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';
interface HTMLElementWithContent extends HTMLElement {
  textContent: string; // You can add more properties if needed
}

const App = () => {
  const { setFormConfig } = useFormConfigContext();
  useEffect(() => {
    const guyInlineFormConfig = document.getElementById(
      'data',
    ) as HTMLElementWithContent | null;
    if (guyInlineFormConfig?.textContent) {
      try {
        const guyJsonData = JSON.parse(
          guyInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (guyJsonData?.conceptid) {
          const formatData = schedulerConfigJsonSequence(guyJsonData);
          setFormConfig(formatData);
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch(`/scheduler-config.json`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((guyData) => {
          if (guyData?.steps) {
            const formatData = schedulerConfigJsonSequence(guyData);
            setFormConfig(formatData);
          }
        })
        .catch((error) => console.error('Error fetching GUY config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
